import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import changeImg from '../../../assets/change_password.svg';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';
import { SIGN_IN_FORM } from '../../../constants/FormNames';

const ChangePassword = () => {
	const navigate = useHistory();
	const [err, setErr] = useState(false);

	const handleChangePassword = () => {
		console.log('change password');
	};

	return (
		<div className='signup__container'>
			<div className='signup__box'>
				<p className='company__name'>
					<p onClick={() => navigate.push('/home')}>Webbler</p>
				</p>
				<p className='signup_text'>
					New user? <p onClick={() => navigate.push('/signup')}>Sign up</p>
				</p>
				<div className='box'>
					<div className='img_wrap'>
						<img className='login_img' src={changeImg} alt='Login image' />
					</div>
					<div className='form'>
						<div className='text_box'>
							<h3 className='welcome'>Enter New Password</h3>
							<h6 className='welcome_sub1'>reset your password</h6>
						</div>
						<div className='inputbox-container'>
							<div className='input_box'>
								<TextInput
									onFocus={() => setErr(false)}
									type='password'
									name='newPassword'
									transform='lower'
									id='newPassword'
									placeholder='New Password'
									form={SIGN_IN_FORM}
									validations={[]}
									hidden={false}
									rightSideIcon={null}
									mainIcon={null}
								/>
								<TextInput
									onFocus={() => setErr(false)}
									type='password'
									name='reTypePassword'
									transform='lower'
									id='reTypePassword'
									placeholder='Re-type Password'
									form={SIGN_IN_FORM}
									validations={[]}
									hidden={false}
									rightSideIcon={null}
									mainIcon={null}
								/>
								<span
									className={err ? 'form-error-message visible' : 'form-error-message'}
								>
									Username or Password invalid!
								</span>
							</div>
						</div>
						<div className='bottom_group'>
							<div className='btn_box'>
								<Button
									active
									diactivated={false}
									clicked={!err}
									className='login'
									labal={'Change Password'}
									onClickEvent={() => handleChangePassword()}
								/>
							</div>
							<div className='sso'>
								<div className='sso__icons'>
									<p>Sign in wtih</p>
									<i className='fa fa-facebook-official' aria-hidden='true'></i>
									<i className='fa fa-google' aria-hidden='true'></i>
									<i className='fa fa-twitter' aria-hidden='true'></i>
								</div>
							</div>
							<div className='signup_bottom'>
								Don't have an account?
								<span onClick={() => navigate.push('/signup')}>Sign up</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChangePassword;
